import React, {Component} from 'react';
import classNames from 'classnames';
import style from "./_button.module.scss";

export default class NTMButton extends Component {

	render() {

		let type, className;
		let props = Object.assign({}, this.props);

		className = classNames(style.magico);
		if (!props.style) props.style = {};

		if (props.primary) {
			className = classNames(className, style.primary);
		}
		if (props.secondary) {
			className = classNames(className, style.secondary);
		}
		if (props.unselected) {
			className = classNames(className, style.unselected);
		}

		if (props.outline) {
			className = classNames(className, style.outline);
		}

		if (props.block) {
			className = classNames(className, style.block);
		}

		if (props.circle) {
			className = classNames(className, style.circle);
		}

		if (props.color) {
			if (props.outline) {
				props.style.color = props.color;
				props.style.borderColor = props.color;
			} else {
				props.style.backgroundColor = props.color;
				props.style.color = "white";
			}
		}


		if(props.className) {
			className = classNames(className, props.className);
		}
		delete props.outline;
		delete props.circle;
		delete props.primary;
		delete props.secondary;
		delete props.red;

		return (
			<button {...props} className={className}>
				{this.props.children}
			</button>
		);
	}
}